import React from 'react';

const PageTitle: React.FC = ({ children }) => (
  <h1 className="w-full mt-8 mb-0 text-center">{children}</h1>
);

export default PageTitle;
